import styles from './MbtiKnowType.module.scss'
import Flex from '@dashboard/components/Flex'
import Dropdown from '@dashboard/components/Dropdown'
import Card from '@dashboard/components/Card'
import logger from '@crystal-eyes/utils/logger'
import useAuth from '@crystal-eyes/hooks/useAuth'
import { fetchV3ApiAuthed } from '@crystal-eyes/utils/apis/v3Api'
import { DropdownOption } from '@dashboard/lib/types'
import useAssessments from '@crystal-eyes/hooks/profiles/personality/useAssessments'
import ActionButton from '@crystal-eyes/components/elements/Button/ActionButton'

import Buttons from '@dashboard/components/Buttons'
import { useState } from 'react'

interface Identity {
  id: string
}

const MYERS_BRIGGS_TYPE_OPTIONS: DropdownOption[] = [
  { label: 'ENTP', value: 'ENTP' },
  { label: 'ENTJ', value: 'ENTJ' },
  { label: 'ENFP', value: 'ENFP' },
  { label: 'ENFJ', value: 'ENFJ' },
  { label: 'ESTP', value: 'ESTP' },
  { label: 'ESTJ', value: 'ESTJ' },
  { label: 'ESFP', value: 'ESFP' },
  { label: 'ESFJ', value: 'ESFJ' },
  { label: 'INTP', value: 'INTP' },
  { label: 'INTJ', value: 'INTJ' },
  { label: 'INFP', value: 'INFP' },
  { label: 'INFJ', value: 'INFJ' },
  { label: 'ISTP', value: 'ISTP' },
  { label: 'ISTJ', value: 'ISTJ' },
  { label: 'ISFP', value: 'ISFP' },
  { label: 'ISFJ', value: 'ISFJ' },
]

const MbtiKnowType = ({
  onFinish,
  identity,
}: {
  onFinish?: () => void
  identity?: Identity
}) => {
  const { data: auth } = useAuth()
  const [selectedType, setSelectedType] = useState('')
  const { refresh } = useAssessments({ identity })
  const handleTypeChange = (option: DropdownOption) => {
    setSelectedType(option.value || '')
  }
  const submitAssessment = async () => {
    logger.info('Submitting MBTI Known Type', selectedType)
    return fetchV3ApiAuthed(auth, 'myers_briggs', {
      method: 'POST',
      body: JSON.stringify({
        text_type: selectedType,
      }),
    })
      .then(() => {
        return refresh()
      })
      .finally(() => {
        if (onFinish) onFinish()
      })
  }

  return (
    <div className={styles.container}>
      <Card title="Select 16-Personality Type" plain center paddedTitle>
        <div className={styles.imgSubtitle}>
          If you already know your 16-Personality type, select it below.
        </div>
        <div className={styles.myersBriggsDropdown}>
          <Flex justifyCenter fullWidth>
            <Dropdown
              options={MYERS_BRIGGS_TYPE_OPTIONS}
              value={selectedType}
              onChange={handleTypeChange}
              placeholder="Select type..."
              maxHeight={200}
            />
          </Flex>
          <Buttons>
            <ActionButton onClick={submitAssessment} disabled={!selectedType}>
              Submit
            </ActionButton>
          </Buttons>
        </div>
      </Card>
    </div>
  )
}

export default MbtiKnowType
